import { HOST } from './webpackConstants'
import { handleWidgetMessages } from './lib/beedirect-modal'
import {
    buildQueryStringFromDataAttributes,
    getDimensionValue,
} from './lib/attributes'
;(function () {
    function createMainIframe(targetElement: Element, index: number) {
        const width = getDimensionValue(
            targetElement.getAttribute('data-width'),
            300
        )
        const height = getDimensionValue(
            targetElement.getAttribute('data-height'),
            300
        )

        if (width === null || height === null) {
            throw new Error(
                'Beequip widget not rendered: invalid configured values for width or height'
            )
        }

        const iframe = document.createElement('iframe')
        iframe.src = `${HOST}/calculator/index.html?referrer=${encodeURIComponent(
            window.location.href
        )}&${buildQueryStringFromDataAttributes(targetElement.attributes)}`
        iframe.id = `beequip-calculator-${index + 1}`
        iframe.allowFullscreen = true
        iframe.setAttribute('scrolling', 'no')
        iframe.frameBorder = '0'
        iframe.style.cssText = `position: static; visibility: visible; display: inline-block; width: ${width}; height: ${height}; padding: 0px; border: medium none; max-width: 100%; min-width: 180px; margin-top: 0px; margin-bottom: 0px; min-height: 200px;`

        window.addEventListener('message', handleWidgetMessages, false)

        return iframe
    }

    const allWidgets = document.querySelectorAll('.beequip-calculator')
    for (let i = 0; i < allWidgets.length; i++) {
        const targetElement = allWidgets[i]
        const iframe = createMainIframe(targetElement, i)

        if (targetElement.parentNode === null) {
            continue
        }

        targetElement.parentNode.replaceChild(iframe, targetElement)
    }
})()
